export const money = (n) =>
  n == null
    ? ""
    : `${n < 0 ? "-" : ""}$${Math.round(Math.abs(n)).toLocaleString("en-US")}`;

export const signedMoney = (n) => `${n >= 0 ? "+" : "-"}${money(Math.abs(n))}`;

// Rates keep their decimals ($4.50/kg must not read as $5).
export const rate = (n) =>
  n == null
    ? ""
    : `$${n.toLocaleString("en-US", { maximumFractionDigits: 2 })}`;

export const qty = (n) =>
  n == null ? "" : n.toLocaleString("en-US", { maximumFractionDigits: 2 });

// Axis ticks: $12K rather than $12,000.
export const compactMoney = (n) =>
  `$${new Intl.NumberFormat("en-US", { notation: "compact" }).format(n)}`;
